import { type GiftItemResponseType, GiftStatus } from '../../../../../pages/my/gifts/sent';
import type { SentGiftItemProps } from '../sent/SentGiftItem';

export function transformGiftStatus(
  status: GiftItemResponseType['status'],
): SentGiftItemProps['status'] {
  switch (status) {
    case 'READY_TO_RECEIVE':
      return GiftStatus.PENDING;
    case 'RECEIVED':
      return GiftStatus.ACCEPTED;
    case 'EXPIRED':
      return GiftStatus.REFUNDED;
    case 'CANCELED':
      return GiftStatus.REFUNDED;
    default:
      return GiftStatus.PENDING;
  }
}
